import React, { useState } from 'react';
import Select from 'react-select';
import { getTransaction, getComplaint, getComplaintTrack, } from 'requests/user';
import axios from 'axios';
import Swal from 'sweetalert2';


const PartnerList = () => {
    const [Complaint, setComplaint] = useState(1);
    // const [complaintType, setComplaintType] = useState({ value: 'transaction', label: 'Transaction' });
    const [disposition, setDisposition] = useState({
        value: 'Transaction Successful, account not updated',
        label: 'Transaction Successful, account not updated',
    });

    const tabdesignClick = (index) => setComplaint(index);
    const [complaintType, setComplaintType] = useState(null);
    const [txnRefId, setTxnId] = useState(localStorage.getItem('txnRefId') || '');
    const [mobileNumber, setMobileNumber] = useState(localStorage.getItem('mobileNumber') || '');

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [description, setDescription] = useState('');
    const [complaintDescription, setComplaintDescription] = useState('');
    const [transactionDetails, setTransactionDetails] = useState(null);
    const [assigned, setAssigned] = useState(null);
    const token = localStorage.getItem('token');
    const [complaintId, setComplaintId] = useState('');
    const [error, setError] = useState('');

    const dispositionOptions = [
        { value: 'Transaction Successful, account not updated', label: 'Transaction Successful, account not updated' },
        { value: 'Amount deducted, biller account credited but transaction ID not received', label: 'Amount deducted, biller account credited but transaction ID not received' },
        { value: 'Amount deducted, biller account not credited & transaction ID not received', label: 'Amount deducted, biller account not credited & transaction ID not received' },
        { value: 'Amount deducted multiple times', label: 'Amount deducted multiple times' },
        { value: 'Double payment updated', label: 'Double payment updated' },
        { value: 'Erroneously paid in wrong account', label: 'Erroneously paid in wrong account' },
        { value: 'Others, provide details in description', label: 'Others, provide details in description' },
    ];

    const handleComplaintTypeChange = (selected) => {
        setComplaintType(selected);
        if (selected.value === 'txnRefId') {
            setTxnId(localStorage.getItem('txnRefId') || '');
            setMobileNumber('');
        } else if (selected.value === 'mobile') {
            setMobileNumber(localStorage.getItem('mobileNumber') || '');
            setTxnId('');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        let trackType = '';
        let trackValue = '';
        if (complaintType?.value === 'txnRefId') {
            trackType = 'TRANS_REF_ID';
            trackValue = txnRefId;
        } else if (complaintType?.value === 'mobile') {
            trackType = 'MOBILE_NO';
            trackValue = mobileNumber;
        } else {
            setError('Please select a valid search type and enter a value.');
            return;
        }

        const payload = {
            trackType,
            trackValue,
            fromDate: startDate,
            toDate: endDate,
        };

        try {
            const res = await getTransaction(payload);
            if (res.data.status === '1') {
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Transaction fetched successfully!',
                    timer: 2000,
                    showConfirmButton: true,
                });
                setTransactionDetails(res.data.data.txnList);
                setError('');
            } else {
                const apiError =
                    res.data.errors?.trackValue?.[0] ||
                    res.data.message ||
                    'Failed to fetch transaction status';
                setError(apiError);
                setTransactionDetails(null);
            }
        } catch (error) {
            console.error('Error fetching transaction:', error);
            setError('An error occurred while fetching transaction.');
            setTransactionDetails(null);
        }
    };

    const handleComplaint = async (e) => {
        e.preventDefault();

        if (!txnRefId || !complaintDescription || !disposition?.value) {
            Swal.fire('Error', 'Please fill in all required fields.', 'error');
            return;
        }

        const payload = {
            complaintType: 'Transaction',
            complainDesc: complaintDescription,
            txnRefId,
            complaintDisposition: disposition.value,
        };

        try {
            const res = await getComplaint(payload);
            if (res.data.status === '1') {
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Complaint registered successfully!',
                    timer: 2000,
                    showConfirmButton: true,
                });
                localStorage.setItem('complaintId', res.data.data.complaintId);
            } else {
                Swal.fire('Error', res.data.message || 'Complaint registration failed', 'error');
            }
        } catch (error) {
            console.error('Error registering complaint:', error);
            Swal.fire('Error', 'An error occurred while registering the complaint.', 'error');
        }
    };

    const handleComplaintTrack = async (e) => {
        e.preventDefault();
        setError('');

        if (!complaintId.trim()) {
            setError('Please enter a valid Complaint ID.');
            return;
        }

        const payload = {
            complaintType: 'Transaction',
            complaintId,
        };

        try {
            const res = await getComplaintTrack(payload);
            if (res.data.status === 1) {
                setAssigned(res.data.data);
                setError('');
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Complaint status fetched successfully!',
                    timer: 2000,
                    showConfirmButton: true,
                });
            } else {
                setError(res.data.message || 'Failed to fetch complaint status');
            }
        } catch (error) {
            console.error('Error fetching complaint status:', error);
            Swal.fire('Error', 'An error occurred while fetching complaint status.', 'error');
        }
    };

    return (
        <section id='complaint'>
            <div className="container">
                <div className="complainttab">
                    <div className="tabdesign_button">
                        <button className={`custumtab buttondesign ${Complaint === 1 ? "active" : ""}`} onClick={() => tabdesignClick(1)}>Register Complaint</button>
                        <button className={`custumtab buttondesign ${Complaint === 2 ? "active" : ""}`} onClick={() => tabdesignClick(2)}>Complaint Tracking</button>
                        <button className={`custumtab buttondesign ${Complaint === 3 ? "active" : ""}`} onClick={() => tabdesignClick(3)}>Transaction Status</button>
                    </div>

                    {/* Tab 1 - Register Complaint */}
                    {Complaint === 1 && (
                        <div className="tabcontent tabdesigncontent">
                            <div className="tab_design_details">
                                <form onSubmit={handleComplaint}>
                                    <div className="margin-bottom-custum">
                                        <label className="form-label">Select Search Type</label>
                                        <Select
                                            className='billcategorydesign'
                                            value={complaintType}
                                            // onChange={(selected) => setComplaintType(selected)}
                                            onChange={handleComplaintTypeChange}
                                            options={[
                                                { value: 'txnRefId', label: 'Txn ID' },
                                                { value: 'mobile', label: 'Mobile Number' }
                                            ]}
                                        />
                                    </div>
                                    {complaintType?.value === 'txnRefId' && (
                                        <div className="margin-bottom-custum">
                                            <label className="form-label">Txn ID</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={txnRefId}
                                                onChange={(e) => setTxnId(e.target.value)}
                                            />
                                        </div>
                                    )}

                                    {complaintType?.value === 'mobile' && (
                                        <div className="margin-bottom-custum">
                                            <label className="form-label">Mobile Number</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={mobileNumber}
                                                onChange={(e) => setMobileNumber(e.target.value)}
                                                maxLength={10}
                                            />
                                        </div>
                                    )}

                                    {complaintType?.value === 'mobile' && mobileNumber && (
                                        <div className="row">
                                            <div className="col-md-6 margin-bottom-custum">
                                                <label className="form-label">Start Date</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={startDate}
                                                    onChange={(e) => setStartDate(e.target.value)}
                                                />
                                            </div>
                                            <div className="col-md-6 margin-bottom-custum">
                                                <label className="form-label">End Date</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={endDate}
                                                    onChange={(e) => setEndDate(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    )}

                                    <div className="margin-bottom-custum">
                                        <label className="form-label">Select Disposition*</label>
                                        <Select
                                            className='billcategorydesign'
                                            value={disposition}
                                            onChange={setDisposition}
                                            options={dispositionOptions}
                                        />
                                    </div>
                                    <div className="margin-bottom-custum">
                                        <label className="form-label">Description</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={complaintDescription}
                                            onChange={(e) => setComplaintDescription(e.target.value)}
                                        />
                                    </div>

                                    <button type="submit" className="submitcomplaint">Submit Complaint</button>
                                </form>
                            </div>
                        </div>
                    )}

                    {/* Tab 2 - Complaint Tracking */}
                    {Complaint === 2 && (
                        <>
                            <div className="tabcontent tabdesigncontent">
                                <div className="tab_design_details">
                                    <form onSubmit={handleComplaintTrack}>
                                        {/* <div className="margin-bottom-custum">
                      <label className="form-label">Complaint Type</label>
                      <Select
                        className='billcategorydesign'
                        value={complaintType}
                        onChange={setComplaintType}
                        options={[{ value: 'transaction', label: 'Transaction' }]}
                      />
                    </div> */}
                                        <div className="margin-bottom-custum">
                                            <label className="form-label">Complaint ID</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={complaintId}
                                                onChange={(e) => setComplaintId(e.target.value)}
                                                placeholder="Enter Complaint ID"
                                            />
                                            {error && <div className="text-danger mt-1">{error}</div>}
                                        </div>

                                        <button type="submit" className="submitcomplaint">Submit</button>
                                    </form>
                                </div>
                            </div>

                            {assigned && (
                                <div className="complaintregister">
                                    <div className="headingregister">
                                        <h5>Complaint Status</h5>
                                    </div>
                                    <div className="complaintid">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <p>Complaint ID</p>
                                            <p><strong>{assigned.complaintId || 'N/A'}</strong></p>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <p>Complaint Assigned</p>
                                            <p>{assigned.complaintAssigned || 'Not Assigned'}</p>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <p>Complaint Status</p>
                                            <p>{assigned.complaintStatus || 'N/A'}</p>
                                        </div>

                                    </div>
                                </div>
                            )}
                        </>
                    )}

                    {/* Tab 3 - Transaction Status */}
                    {Complaint === 3 && (
                        <>
                            <div className="tabcontent tabdesigncontent">
                                <div className="tab_design_details">

                                    <form onSubmit={handleSubmit}>
                                        <div className="margin-bottom-custum">
                                            <label className="form-label">Select Search Type</label>
                                            <Select
                                                className='billcategorydesign'
                                                value={complaintType}
                                                // onChange={(selected) => setComplaintType(selected)}
                                                onChange={handleComplaintTypeChange}
                                                options={[
                                                    { value: 'txnRefId', label: 'Txn ID' },
                                                    { value: 'mobile', label: 'Mobile Number' }
                                                ]}
                                            />
                                        </div>

                                        {complaintType?.value === 'txnRefId' && (
                                            <div className="margin-bottom-custum">
                                                <label className="form-label">Txn ID</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={txnRefId}
                                                    onChange={(e) => setTxnId(e.target.value)}
                                                />
                                                {error && <div className="text-danger mb-3">{error}</div>}
                                            </div>
                                        )}

                                        {complaintType?.value === 'mobile' && (
                                            <div className="margin-bottom-custum">
                                                <label className="form-label">Mobile Number</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={mobileNumber}
                                                    onChange={(e) => setMobileNumber(e.target.value)}
                                                    maxLength={10}
                                                />
                                                {error && <div className="text-danger mb-3">{error}</div>}
                                            </div>
                                        )}
                                        {complaintType?.value === 'mobile' && mobileNumber && (
                                            <div className="row">
                                                <div className="col-md-6 margin-bottom-custum">
                                                    <label className="form-label">Start Date</label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        value={startDate}
                                                        onChange={(e) => setStartDate(e.target.value)}
                                                    />
                                                </div>
                                                <div className="col-md-6 margin-bottom-custum">
                                                    <label className="form-label">End Date</label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        value={endDate}
                                                        onChange={(e) => setEndDate(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        <button type="submit" className="submitcomplaint">Submit</button>
                                    </form>

                                </div>
                            </div>

                            {transactionDetails && (
                                <div className="complaintregister">
                                    <div className="headingregister">
                                        <h5>Transaction Details</h5>
                                    </div>
                                    <div className="complaintid">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <p>Txn ID</p>
                                            <p><strong>{transactionDetails.txnReferenceId}</strong></p>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <p>Status</p>
                                            <p><strong>{transactionDetails.txnStatus}</strong></p>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <p>Amount</p>
                                            <p><strong>₹{transactionDetails.amount}</strong></p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        </section >
    );
};

export default PartnerList;
